import { useContext, useEffect, useState } from 'react';

import ApiCard, { ApiCardData, ApiCardStatus } from 'components/apiCard';
import { CtApiJob } from 'models/general';
import { StoreContext } from 'models/import';
import { getMockData } from 'services/api';

export interface ApiCardDetailProps {
  id: number;
}

function ApiCardDetail(props: ApiCardDetailProps) {
  const [cardData, setCardData] = useState<ApiCardData | null>(null);
  const { platform } = useContext(StoreContext);

  // TODO: Replace mock endpoint with real one
  const getDetails = (_id: number) => getMockData<Record<string, CtApiJob>>(`/job/${_id}`);
  const mapDetails = (data: CtApiJob): ApiCardData => ({
    logoUrl: platform?.logo_uri || '',
    key: data.credential_key,
    customName: data.custom_name,
    autosync: data.autosync,
    details: [
      { key: 'Created', value: data.created },
      { key: 'Last sync', value: data.last_sync },
      { key: 'Last import', value: data.last_import },
      { key: 'Trade Pairs', value: data.trade_pairs },
      { key: 'Notification', value: data.notification ? 'Yes' : '-' },
      { key: 'Label', value: data.label },
    ],
    status: data.status as unknown as ApiCardStatus,
  });

  useEffect(() => {
    const jobId = props.id;

    getDetails(jobId)
      .then((res) => {
        console.log(res);
        const mappedData = mapDetails(res.data);

        setCardData(mappedData);
      }, () => { });
  }, []);

  if (!cardData) return null;

  return (
    <ApiCard data={cardData} />
  );
}

export default ApiCardDetail;
